export const pageCoreContent = 'page-core-content';